module.exports = __webpack_public_path__ + "img/DIM.54414f07.png";